import { axiosPrivateInstance } from 'libs/axios';
import { GET_ALL_STORAGE_CONDITION } from 'utils/serviceUrls';

const getAllStorageConditionService = async () => {
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(GET_ALL_STORAGE_CONDITION)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default getAllStorageConditionService;
